module.exports = __webpack_public_path__ + "media/loadingscreen.152b04b6.mp4";